<template>
  <div class="group-listing">
    <div class="mb-12">
      <v-row class="flex-column flex-md-row">
        <v-col>
          <v-card-title
            class="display-2 letter-spacing-compact font-weight-bold mb-md-12 align-center"
          >
            Custom Trip
          </v-card-title>
        </v-col>
      </v-row>
      <validation-observer ref="validator">
        <v-form @submit.prevent="submit()">
          <v-row>
            <v-col sm="12" lg="7">
              <v-container fluid class="mx-1060">
                <v-row>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <ValidationProvider
                      name="name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        name="name"
                        :error-messages="errors"
                        v-model="request.name"
                        label="Trip Name"
                        required
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <validation-provider
                      name="tour_type"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-select
                        name="type_id"
                        :items="types"
                        item-text="name"
                        :error-messages="errors"
                        item-value="id"
                        v-model="request.tour_type_id"
                        label="Type of Tour"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <DatePicker
                      name="check_in"
                      rules="required"
                      v-model="request.check_in"
                      label="Check in date"
                      class="mb-6"
                    />
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <DatePicker
                      name="check_out"
                      rules="required|after:@check_in,true"
                      v-model="request.check_out"
                      label="Check out date"
                      :min="request.check_in"
                      class="mb-6"
                    />
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 12"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <LocationField
                      name="location"
                      v-model="request.location"
                      :pickLocationManually="false"
                      :automaticClose="false"
                      :required="true"
                    />
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 12"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <MemberSightings
                      :index="0"
                      :member="loggedInUser"
                      :request="request"
                    />
                    <div class="mb-10">
                      <span
                        v-if="!hasSpecies"
                        id="species-error"
                        :class="speciesClass"
                      >
                        Please Select Species
                      </span>
                      <span
                        v-if="!request.amount > 0"
                        id="amount"
                        :class="speciesClass"
                      >
                        Please Add Amount
                      </span>
                    </div>
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 12"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <v-row class="justify-lg-space-between align-center">
                      <v-col class="pa-0">
                        <v-card-title
                          class="py-0 title font-weight-bold letter-spacing-normal"
                        >
                          Select a Project make your donation.
                        </v-card-title>
                      </v-col>
                    </v-row>
                    <ProjectSelector
                      class="mt-4"
                      v-model="request.project_id"
                    />
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 12"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <v-row class="justify-lg-space-between align-center">
                      <v-col class="pa-0">
                        <v-card-title
                          class="py-0 title font-weight-bold letter-spacing-normal"
                        >
                          Enter your payment information.
                        </v-card-title>
                      </v-col>
                    </v-row>
                    <div class="stripe-payment mt-4">
                      <StripeElements
                        :stripe-key="stripeKey"
                        :instance-options="instanceOptions"
                        :elements-options="elementsOptions"
                        #default="{ elements }"
                        ref="elms"
                      >
                        <div class="cardElement">
                          <StripeElement
                            type="card"
                            :elements="elements"
                            :options="elementStyle"
                            ref="card"
                          />
                        </div>
                      </StripeElements>
                      <span style="color: red" v-if="errors">
                        {{ errors.message }}
                      </span>
                    </div>

                    <v-card class="px-3 py-3 my-12">
                      <v-list flat color="white">
                        <v-list-item
                          :ripple="false"
                          inactive
                          class="justify-space-between px-xl-12 px-lg-5"
                        >
                          <div class="text-left font-weight-bold mr-6">
                            Service Charge:({{ serviceCharge }}%)
                          </div>

                          <div class="text-right notranslate">
                            {{ chargeBreakDown.service }}
                          </div>
                        </v-list-item>

                        <v-list-item
                          :ripple="false"
                          inactive
                          class="justify-space-between px-xl-12 px-lg-5"
                        >
                          <div class="text-left font-weight-bold mr-6">
                            Stripe Charge ({{ stripeCharge }}%)
                          </div>

                          <div class="text-right notranslate">
                            {{ chargeBreakDown.stripe }}
                          </div>
                        </v-list-item>

                        <v-list-item
                          :ripple="false"
                          inactive
                          class="justify-space-between px-xl-12 px-lg-5"
                        >
                          <div class="text-left font-weight-bold mr-6">
                            Project
                          </div>

                          <div class="text-right notranslate">
                            {{ chargeBreakDown.project }}
                          </div>
                        </v-list-item>
                        <v-list-item
                          :ripple="false"
                          inactive
                          class="justify-space-between px-xl-12 px-lg-5"
                        >
                          <div class="text-left font-weight-bold">Total</div>

                          <div class="text-right notranslate">
                            {{ chargeBreakDown.total }}
                          </div>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col>
              <div class="position-fixed"></div>
            </v-col>
          </v-row>
        </v-form>
      </validation-observer>
      <v-card-actions class="flex-column flex-md-row px-5 custom-trips-button">
        <v-btn
          large
          color="white"
          class="elevation-1 font-weight-bold px-8 mr-10"
          min-width="275px"
          @click="goToList()"
        >
          Cancel
        </v-btn>
        <v-btn
          large
          color="primary"
          class="elevation-1 font-weight-bold px-8"
          min-width="275px"
          @click.prevent="submit()"
          :loading="request.submitting"
          :disabled="request.submitting || (!request.id && request.submitted)"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import Request from '@request/CustomGroupRequest';
import Model from '@models/Group';
import TourRequest from '@request/TourRequest';
import { StripeElement, StripeElements } from 'vue-stripe-elements-plus';
import ProjectSelector from '@components/ProjectSelector.vue';
import Storage from '@services/Storage';

const elementStyle = {};

const SERVICE_CHARGE = 17;
const STRIPE_CHARGE = 3;

const storage = new Storage();

export default {
  name: 'Create',
  metaInfo: {
    titleTemplate: '%s - Manage Group',
  },
  components: {
    ProjectSelector,
    DatePicker: () => import('@components/utilities/DatePicker'),
    LocationField: () => import('@components/utilities/LocationField'),
    MemberSightings: () => import('./_partials/TripSightings'),
    StripeElements,
    StripeElement,
  },
  data() {
    return {
      serviceCharge: SERVICE_CHARGE,
      stripeCharge: STRIPE_CHARGE,
      elementStyle,
      request: new Request(this.$refs),
      group: {},
      typeRequest: new TourRequest(this.$refs, {
        species: [],
        species_ids: [],
      }),
      model: new Model(),
      types: [],
      stripeKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      instanceOptions: {},
      elementsOptions: {},
      errors: '',
      speciesClass: 'd-none',
      loggedInUser: null,
    };
  },
  computed: {
    hasSpecies() {
      return this.request.species.length > 0;
    },
    chargeBreakDown() {
      const options = { style: 'currency', currency: 'USD' };
      const formatter = new Intl.NumberFormat('en-US', options).format;
      const serviceCharge = (SERVICE_CHARGE / 100) * this.request.amount;
      const stripeCharge = (STRIPE_CHARGE / 100) * this.request.amount;
      const donationAmount = this.request.amount - stripeCharge - serviceCharge;

      return {
        service: formatter(serviceCharge),
        stripe: formatter(stripeCharge),
        project: formatter(donationAmount),
        total: formatter(this.request.amount),
      };
    },
  },
  methods: {
    async submit() {
      this.request.species.length > 0 && this.request.amount > 0
        ? (this.speciesClass = 'd-none')
        : (this.speciesClass = '');
      if (await this.$refs.validator.validate()) {
        if (
          !this.request.id ||
          (this.request.id &&
            this.$refs.validator.flags.changed &&
            this.request.species.length &&
            this.request.amount)
        ) {
          this.pay();
        }
      }
    },

    goToList() {
      if (this.$route.from && this.$route.from.name === 'custom-trips') {
        this.$route.back();
        return;
      }
      this.$router.push({
        name: 'custom-trips',
      });
    },
    async fetchTourTypes() {
      let response = await this.typeRequest.model.getTypes();
      if (response) {
        this.types = response.data;
      }
    },
    async pay() {
      this.errors = '';
      const groupComponent = this.$refs.elms;
      const card = this.$refs.card;
      const cardElement = card.stripeElement;
      await groupComponent.instance
        .createToken(cardElement)
        .then(async (result) => {
          if (result.error) {
            this.errors = result.error;
            return;
          }
          this.request.stripe_token = result.token.id;
          let response = await this.request.submit();
          if (response) {
            this.goToList();
          }
        });
    },
    async getLoggedInUser() {
      this.loggedInUser = this.$store.state.auth.user;
    },
  },
  async mounted() {
    await this.getLoggedInUser();
    this.fetchTourTypes();
  },
};
</script>

<style lang="scss">
.stripe-payment {
  .cardElement {
    height: 44px;
    border: 2px solid #c4c4c4;
    display: flex;
    align-items: center;
    padding: 0 12px;
    border-radius: 1px;

    > * {
      width: 100%;
    }
  }

  .row {
    display: flex;
    justify-content: space-between;
  }

  .cardNumber {
    width: 100%;
  }

  .cvc {
    max-width: 300px;
    min-width: 70px;
    width: 40%;
  }

  .expiryDate {
    max-width: 300px;
    min-width: 120px;
    width: 40%;
  }
}
#species-error {
  color: #b71c1c;
}
</style>
